/*
 * Sitewide-sale countdown driver. Drives every [data-sale-countdown] on the page
 * from a single interval. The deadline is read from data-target (ms since epoch,
 * resolved server-side in the store timezone). Each instance hides itself when
 * its deadline passes, so an expired sale never shows a frozen 00:00:00.
 *
 * Loaded once from layout/theme.liquid, gated by settings.sitewide_sale_enabled.
 */
(function () {
  if (window.__saleCountdownInit) return;
  window.__saleCountdownInit = true;

  function pad(n) {
    return (n < 10 ? '0' : '') + n;
  }

  function init() {
    var clocks = Array.prototype.slice.call(
      document.querySelectorAll('[data-sale-countdown]')
    );
    if (!clocks.length) return;

    function tick() {
      var now = Date.now();
      clocks.forEach(function (el) {
        var target = parseInt(el.getAttribute('data-target'), 10);
        if (!target) {
          el.style.display = 'none';
          return;
        }
        var diff = Math.floor((target - now) / 1000);
        if (diff <= 0) {
          el.style.display = 'none';
          return;
        }
        var d = Math.floor(diff / 86400);
        diff -= d * 86400;
        var h = Math.floor(diff / 3600);
        diff -= h * 3600;
        var m = Math.floor(diff / 60);
        var s = diff - m * 60;
        var set = function (k, v) {
          var node = el.querySelector('[data-cd="' + k + '"]');
          if (node) node.textContent = pad(v);
        };
        set('days', d);
        set('hours', h);
        set('minutes', m);
        set('seconds', s);
        var sr = el.querySelector('[data-cd-sr]');
        if (sr) {
          sr.textContent =
            'Sale ends in ' + d + ' days, ' + h + ' hours and ' + m + ' minutes';
        }
      });
    }

    tick();
    setInterval(tick, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
